import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import Paginated from 'meteor-paginated-graphql-react'
import FaArchive from 'react-icons/lib/fa/archive'
import numeral from 'numeral'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import RouteMoves from '../RouteMoves'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import MdCancel from 'react-icons/lib/md/cancel'
import Actions from 'src/App/components/Actions'

@withMutation(gql`
  mutation createDynamicSellNote($preparationId: ID) {
    createDynamicSellNote(preparationId: $preparationId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation deleteDynamicSellNote($sellNoteId: ID) {
    deleteDynamicSellNote(sellNoteId: $sellNoteId) {
      success
    }
  }
`)
@withRouter
@withMessage
export default class DynamicSellNoteSelect extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    router: PropTypes.object,
    params: PropTypes.object,
    createDynamicSellNote: PropTypes.func,
    deleteDynamicSellNote: PropTypes.func
  }

  state = {}

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/preparation/${_id}/sellNoteAdvance`)
  }

  getFields() {
    return [
      {title: '', name: '_id', render: () => <FaArchive />},
      {
        title: 'Total a pagar por el Cliente',
        name: 'total',
        render: ({total}) => numeral(total).format('0,0')
      },
      {
        title: 'Id de documento en preparación',
        name: 'preparationId'
      },
      {
        title: '',
        name: ' ',
        render: item => this.renderActions(item)
      }
    ]
  }

  renderActions(item) {
    return (
      <div>
        <span>
          <Actions options={this.renderOptions(item)} />
        </span>
      </div>
    )
  }

  renderOptions(item) {
    return [this.deleteItem(item)]
  }

  deleteItem(item) {
    return (
      <div onClick={() => this.delete(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdCancel size={20} style={{color: 'red'}} />
            </div>
            <div className="col-xs-12 col-sm-9">eliminar</div>
          </div>
        </span>
      </div>
    )
  }

  @autobind
  async create() {
    this.setState({loading: true, errorMessages: null})
    const {preparationId} = this.props.params
    try {
      await this.props.createDynamicSellNote(
        {preparationId: preparationId},
        {refetchQueries: ['dynamicSellNotes']}
      )
      this.props.showMessage('Nota de venta agregada exitosamente!')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    } finally {
      this.refs.paginated.reload()
    }
    this.setState({loading: false})
  }

  async delete(item) {
    const result = window.confirm(
      `¿Realmente quieres eliminar los datos de la nota de venta donde el total a pagar por el cliente es ${
        item.total
      }?`
    )
    if (!result) return
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.deleteDynamicSellNote(
        {sellNoteId: item._id},
        {refetchQueries: ['dynamicSellNotes']}
      )
      this.props.showMessage('Elemento eliminado satisfactoriamente!')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    } finally {
      this.refs.paginated.reload()
    }
    this.setState({loading: false})
  }

  render() {
    const {preparationId} = this.props.params
    return (
      <div className={styles.container}>
        <RouteMoves docId={preparationId} />
        <div className="section">
          <div className="header">
            <h3>Datos de notas de venta</h3>
          </div>
          <Paginated
            loadingComponent={Loading}
            queryName="dynamicSellNotes"
            fields={this.getFields()}
            ref="paginated"
            preparationId={preparationId}
            params="$filter: String $preparationId: String"
            onPress={this.onSelect}
          />
        </div>
        <div className={styles.button}>
          <Button primary onClick={this.create} loading={this.state.loading}>
            Agregar Nota Venta
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/DynamicSellNoteSelect/index.js